package com.futurions.portfolio.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.functions.blur
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backdropFilter
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.css.s
import org.jetbrains.compose.web.dom.A

@Composable
fun ContactSection() {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .padding(top = 100.px, bottom = 100.px)
            .id("contact"),
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier
                .maxWidth(900.px)
                .padding(40.px)
                .backgroundColor(rgba(255, 255, 255, 0.04))
                .backdropFilter(blur(18.px))
                .borderRadius(24.px)
                .boxShadow(
                    offsetX = 0.px,
                    offsetY = 4.px,
                    blurRadius = 26.px,
                    spreadRadius = 8.px,
                    color = rgba(0, 0, 0, 0.35)
                ),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {

            // Title
            SpanText(
                "✉️ Contact Me",
                modifier = Modifier
                    .fontSize(32.px)
                    .fontWeight(FontWeight.Bold)
                    .color(Color.white)
                    .padding(bottom = 16.px)
            )

            // Description
            SpanText(
                "Whether you want to discuss a project, collaborate, or just say hello — I’m always open to talking.",
                modifier = Modifier
                    .fontSize(18.px)
                    .lineHeight(28.px)
                    .color(rgb(220, 220, 220))
                    .textAlign(TextAlign.Center)
                    .maxWidth(700.px)
                    .padding(bottom = 36.px)
            )

            // Social icons row
            Row(
                modifier = Modifier.gap(30.px),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.Center
            ) {
                ContactIcon(
                    "Email",
                    "/tools/mail.png",
                    "https://mail.google.com/mail/?view=cm&fs=1&to=gaurav29k06@gmail.com&su=Hello&body=I%20want%20to%20talk%20about..."
                )
                ContactIcon("GitHub", "/tools/GitHub.svg", "https://github.com/gauravsingh2906")
                ContactIcon("LinkedIn", "/tools/linkedin.png", "https://www.linkedin.com/in/gaurav-singh-913b6728a")
                ContactIcon("PlayStore", "/tools/playstore.png", "https://play.google.com/store/apps/details?id=com.futurion.apps.mindmingle")
            }
        }
    }
}


@Composable
fun ContactIcon(name: String, iconPath: String, link: String) {
    A(href = link, attrs = {
        attr("target", "_blank")
    }) {
        Box(
            modifier = Modifier
                .size(48.px)
                .backgroundColor(rgba(255, 255, 255, 0.08))
                .borderRadius(50.percent)
                .padding(10.px)
                .cursor(Cursor.Pointer)
                .transition(Transition.of("transform", 0.3.s))
            ,
            contentAlignment = Alignment.Center
        ) {
            Image(
                src = iconPath,
                description = name,
                modifier = Modifier.size(100.percent)
            )
        }
    }
}
